module.exports = __webpack_public_path__ + "static/media/javaLogo.84cb0271.png";